export class ListarEdicoesParaCalendarioInputDto{
  mesPublicacao: number;
  anoPublicacao: number;

  constructor(mes: number, ano: number){
    this.mesPublicacao = mes;
    this.anoPublicacao = ano;
  }
}
